'use client';
export { Center } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map